import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import AdminDashboard from './components/AdminDashboard';
import { ThemeProvider, createTheme } from '@mui/material';

const theme = createTheme({
  palette: {
    primary: {
      main: '#D4AF37', // Gold color for branding
    },
    secondary: {
      main: '#000000',
    },
    background: {
      default: '#f7f5f0', // Elegant off-white
    },
  },
  typography: {
    fontFamily: '"Playfair Display", serif',
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #f7f5f0 70%, #e9e3d7 100%)' }}>
        <Router>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </Router>
      </div>
    </ThemeProvider>
  );
}

export default App;
